import { inject, Injectable } from '@angular/core';

import { SonaAuthFacade } from './auth.facade';

/**
 * A facade for the login feature
 */
@Injectable({
    providedIn: 'root'
})
export class SonaAuthSignupFacade {

    private readonly _authFacade = inject(SonaAuthFacade);

    /**
     * Triggers the sign-up / sign-in with Google flow
     */
    signUpWithGoogle() {
        return this._authFacade.signInWithGoogle();
    }

    /**
     * Signs a user up
     */
    signUp(email: string, password: string) {
        return this._authFacade.signUpWithPassword(email, password);
    }

    /**
     * Confirms the sign-up
     *
     * @param token - The token hash provided by Supabase
     * @param type - The type of the token
     * @param termsAccepted - Whether the user accepted the terms
     * @param newsletterAccepted - Whether the user accepted the newsletter
     */
    confirmSignUp(token: string, type: 'signup' | 'invite', termsAccepted: boolean, newsletterAccepted: boolean) {
        return this._authFacade.confirmSignUp(token, type, termsAccepted, newsletterAccepted);
    }
}
